import { bool, number, object, string } from "yup";
import { FLIGHT, STAY_DRIVE } from "./constants.js";
const LOCATION_REQUIRED = 'Please enter a city or airport';
const INVALID_DATE = 'Please select valid dates';
const DISALLOW_INFANT_INTL_FLIGHT = 'Sorry, we do not offer lap infant seating on international flights';
const INFANT_CAPACITY_LIMIT = 'Only one infant per adult is allowed';
const CHILD_AGE_REQUIRED = "Please enter children's age to get the best price for your group";
const TIME_RANGE_ERROR = 'Please make sure the drop-off time is later than the pick-up time.';
const intlLocation = (locationObject)=>locationObject && 'string' == typeof locationObject.countryCode && 'US' !== locationObject.countryCode.toUpperCase();
const isInfantFound = (childrenAges)=>Object.values(childrenAges).some((age)=>0 === Number(age));
const isIntLocationWithInfant = (locationObject, childrenAges)=>intlLocation(locationObject) && isInfantFound(childrenAges);
const hasFlight = (tripType)=>tripType.includes(FLIGHT);
const isInfantOnInternationalTravel = (startLocation, endLocation, childrenAges, tripType)=>{
    if (hasFlight(tripType) && (isIntLocationWithInfant(startLocation, childrenAges) || isIntLocationWithInfant(endLocation, childrenAges))) return DISALLOW_INFANT_INTL_FLIGHT;
    return '';
};
function handleIsInfantOnInternationalTravel() {
    const { startLocation, endLocation, travelers, tripType } = this.parent;
    const { childrenAges } = travelers;
    return !isInfantOnInternationalTravel(startLocation, endLocation, childrenAges, tripType);
}
function handleIsChildrenAgeProvided() {
    const { childrenAges, children } = this.parent;
    if (0 === children) return true;
    const validAgesCount = Object.values(childrenAges || {}).filter((age)=>/^\d+$/.test(String(age)) && Number(age) >= 0).length;
    if (validAgesCount !== children) return this.createError({
        message: CHILD_AGE_REQUIRED,
        path: this.path
    });
    return true;
}
const isInfantLimitReachedPackages = (adults, childrenAges, tripType)=>{
    const lapInfants = Object.values(childrenAges).filter((age)=>{
        const numAge = parseInt(age, 10);
        return !Number.isNaN(numAge) && 0 === numAge;
    });
    const infantCount = lapInfants.length;
    if (tripType?.includes(FLIGHT) && infantCount > adults) return INFANT_CAPACITY_LIMIT;
    return '';
};
function handleIsInfantLimitReachedPackage() {
    const { tripType, travelers } = this.parent;
    const { adults, childrenAges } = travelers;
    return !isInfantLimitReachedPackages(adults, childrenAges, tripType);
}
function handleDateCheck() {
    const formState = this.parent;
    const { tripType, startDate, endDate } = formState;
    const isError = 'FLY:DRIVE' !== tripType && startDate === endDate;
    if (isError) return this.createError({
        message: INVALID_DATE,
        path: this.path
    });
    return true;
}
const packagesSearchFormSchema = object().shape({
    tripType: string(),
    partialStay: bool(),
    startLocation: object().nullable().when('tripType', {
        is: STAY_DRIVE,
        then: (schema)=>schema.nullable(),
        otherwise: (schema)=>schema.nullable().required(LOCATION_REQUIRED)
    }),
    endLocation: object().nullable().required(LOCATION_REQUIRED),
    rcLocation: object().nullable().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.nullable().required(LOCATION_REQUIRED),
        otherwise: (schema)=>schema.nullable()
    }),
    startDate: string().required(INVALID_DATE).test(handleDateCheck),
    endDate: string().required(INVALID_DATE),
    hotelStartDate: string().when('partialStay', {
        is: true,
        then: (schema)=>schema.required(INVALID_DATE)
    }),
    hotelEndDate: string().when('partialStay', {
        is: true,
        then: (schema)=>schema.required(INVALID_DATE)
    }),
    rcPickupDate: string().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.nullable().required(INVALID_DATE)
    }),
    rcDropoffDate: string().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.nullable().required(INVALID_DATE)
    }),
    rcDropoffTime: string().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.test({
                name: 'rcDropoffTime',
                message: TIME_RANGE_ERROR,
                test () {
                    const { rcPickupDate, rcDropoffDate, rcPickupTime, rcDropoffTime } = this.parent;
                    if (!rcPickupDate || !rcDropoffDate || rcPickupDate !== rcDropoffDate) return true;
                    if (!rcPickupTime || !rcDropoffTime) return true;
                    return rcDropoffTime >= rcPickupTime;
                }
            }),
        otherwise: (schema)=>schema.nullable()
    }),
    travelers: object().shape({
        children: number().test({
            name: 'children',
            test () {
                return handleIsChildrenAgeProvided.call(this);
            }
        })
    }),
    isInfantOnInternationalTravel: string().test('isInfantOnInternationalTravel', DISALLOW_INFANT_INTL_FLIGHT, handleIsInfantOnInternationalTravel),
    isInfantLimitReachedPackages: string().test('isInfantLimitReachedPackages', INFANT_CAPACITY_LIMIT, handleIsInfantLimitReachedPackage)
});
const validation = packagesSearchFormSchema;
export { TIME_RANGE_ERROR, validation as default, isInfantLimitReachedPackages, isInfantOnInternationalTravel, packagesSearchFormSchema };
